import React, { useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const body = document.querySelector("body");
    const mobileNavToggleBtn = document.querySelector(".mobile-nav-toggle");

    const mobileNavToggle = () => {
      body.classList.toggle("mobile-nav-active");

      if (mobileNavToggleBtn) {
        mobileNavToggleBtn.classList.toggle("bi-list");
        mobileNavToggleBtn.classList.toggle("bi-x");
      }
    };

    if (mobileNavToggleBtn) {
      mobileNavToggleBtn.addEventListener("click", mobileNavToggle);
    }

    // Close mobile nav when a link is clicked
    const navLinks = document.querySelectorAll("#navmenu a");
    navLinks.forEach((navLink) => {
      navLink.addEventListener("click", () => {
        if (body.classList.contains("mobile-nav-active")) {
          mobileNavToggle();
        }
      });
    });

    // Handle dropdown toggles
    const dropdownToggles = document.querySelectorAll(
      ".navmenu .toggle-dropdown"
    );
    dropdownToggles.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        const parent = toggle.closest("li");
        if (parent) {
          parent.classList.toggle("active");
          const submenu = parent.querySelector("ul");
          if (submenu) {
            submenu.classList.toggle("dropdown-active");
          }
        }
      });
    });

    return () => {
      if (mobileNavToggleBtn) {
        mobileNavToggleBtn.removeEventListener("click", mobileNavToggle);
      }
      navLinks.forEach((navLink) => {
        navLink.removeEventListener("click", mobileNavToggle);
      });
      dropdownToggles.forEach((toggle) => {
        toggle.removeEventListener("click", () => {});
      });
    };
  }, []);

  useEffect(() => {
    const scrollSpy = () => {
      if (typeof window.navmenuScrollspy === "function") {
        window.navmenuScrollspy(); // make function global
      }
    };

    scrollSpy();
    window.addEventListener("scroll", scrollSpy);
    return () => window.removeEventListener("scroll", scrollSpy);
  }, [location]);

  const handleNavLink = (e, sectionId, category = null) => {
    e.preventDefault();
    const id = sectionId.replace("#", "");
    const url = category
      ? `/#${id}?category=${encodeURIComponent(category)}`
      : `/#${id}`;

    if (location.pathname !== "/") {
      navigate(url, { replace: false });
      setTimeout(() => {
        const section = document.querySelector(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }

        // Dispatch custom event
        if (category) {
          window.dispatchEvent(
            new CustomEvent("product-filter", { detail: category })
          );
        }
      }, 300);
    } else {
      navigate(url, { replace: true });

      const section = document.querySelector(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }

      // Dispatch custom event
      if (category) {
        window.dispatchEvent(
          new CustomEvent("product-filter", { detail: category })
        );
      }

      // update hash manually
      window.history.replaceState(null, "", `#${id}`);
    }
  };

  const handleDownloadAndOpen = () => {
    const url = "https://innovexcrop.com/Catalogue.pdf";

    // Trigger download
    const link = document.createElement("a");
    link.href = url;
    link.download = "Catalogue.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Open in new tab
    window.open(url, "_blank");
  };

  return (
    <header
      id="header"
      className={`header d-flex align-items-center fixed-top ${
        location.pathname.startsWith("/product")
          ? "header-product-bg"
          : "header-bg"
      }`}
    >
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="/" className="logo d-flex align-items-center me-auto">
          <img src="/assets/img/Logo-Innovex.png" alt="Logo" />
        </a>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <NavLink
                to="/#home"
                className={({ isActive }) =>
                  location.hash === "#home" ? "active" : ""
                }
                onClick={(e) => handleNavLink(e, "#home")}
              >
                Home
              </NavLink>
            </li>
            <li>
              <a
                href="/#about"
                className={location.hash === "#about" ? "active" : ""}
                onClick={(e) => handleNavLink(e, "#about")}
              >
                About
              </a>
            </li>
            <li
              className={`dropdown ${
                location.hash === "#product" ? "active" : ""
              }`}
            >
              <a href="/#product" onClick={(e) => handleNavLink(e, "#product")}>
                Products
                <i className="bi bi-chevron-down toggle-dropdown" />
              </a>
              <ul>
                <li>
                  <a
                    href="/#product"
                    onClick={(e) => handleNavLink(e, "#product", "insecticide")}
                  >
                    Insecticide
                  </a>
                </li>
                <li>
                  <a
                    href="/#product"
                    onClick={(e) => handleNavLink(e, "#product", "fungicide")}
                  >
                    Fungicide
                  </a>
                </li>
                <li>
                  <a
                    href="/#product"
                    onClick={(e) => handleNavLink(e, "#product", "herbicide")}
                  >
                    Herbicide
                  </a>
                </li>
                <li>
                  <a
                    href="/#product"
                    onClick={(e) => handleNavLink(e, "#product", "pgr")}
                  >
                    Pgr
                  </a>
                </li>
                <li>
                  <a
                    href="/#product"
                    onClick={(e) => handleNavLink(e, "#product", "fertilizer")}
                  >
                    Fertilizer
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a
                href="/#team"
                className={location.hash === "#team" ? "active" : ""}
                onClick={(e) => handleNavLink(e, "#team")}
              >
                Team
              </a>
            </li>
            <li>
              <a
                href="/#contact"
                className={location.hash === "#contact" ? "active" : ""}
                onClick={(e) => handleNavLink(e, "#contact")}
              >
                Contact
              </a>
            </li>
          </ul>

          <i className="mobile-nav-toggle d-xl-none bi bi-list" />
        </nav>
        <button onClick={handleDownloadAndOpen} className="cta-btn">
          Catalogue
        </button>
      </div>
    </header>
  );
};

export default Header;
